import { render } from "./AudienceDialog.vue?vue&type=template&id=995c9cf0&scoped=true"
import script from "./AudienceDialog.vue?vue&type=script&lang=js"
export * from "./AudienceDialog.vue?vue&type=script&lang=js"

import "./AudienceDialog.vue?vue&type=style&index=0&id=995c9cf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-995c9cf0"]])

export default __exports__